/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Component, Input } from "@angular/core";

@Component({
   standalone: false,
   selector: "login-waiting",
   templateUrl: "./login-waiting.component.html"
})
// don't inherit for logging
export class LoginWaitingComponent {
   @Input() fromData;
}
